export class DigestibleError extends Error {
  constructor(
    public message: string,
    public options?: { name?: string | number } & ErrorOptions,
  ) {
    super(message);

    this.name = `${options?.name ?? 'Error'}`;
  }
}
